import { StyleSheet } from 'react-native';
import { Colors } from '@qnpm/q-theme';

const { scenes: { baseColor } } = Colors;

export default StyleSheet.create({
    pageRoot: {
        flex: 1,
        backgroundColor: baseColor.background2
    }
});
